import axios from 'axios'

import config from '../../config.client.js'

const url = config.apiUrl

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.status === 401) {
      return (window.location.href = '/login')
    }

    return Promise.reject(error)
  }
)

export default {
  login: (username, password) =>
    axios.post(url + 'login', {
      username: username,
      password: password
    }),

  logout: () => axios.delete(url + 'login')
}



// WEBPACK FOOTER //
// ./src/services/authentication.js